export const SOCIAL_PLATFORMS = ['googleMyBusiness', 'instagram', 'facebook', 'linkedIn'] as const;
